import './icon-ellipsis-close.scss';

import { h } from 'preact';

export function IconEllipsisClose({
  open = false,
  width = 40,
  height = 40,
  fill = 'currentColor',
}) {
  const spanStyle = { background: fill };

  return (
    <div
      class={`ellipsis-close-icon ${open ? 'open' : ''}`}
      style={{ width: `${width}px`, height: `${height}px` }}
    >
      <span style={spanStyle}></span>
      <span style={spanStyle}></span>
      <span style={spanStyle}></span>
    </div>
  );
}
